module.exports = __webpack_public_path__ + "static/media/(V)_MG_6256_-_Joias_Contenporaneas.f6d60af6.jpg";